import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-notail",
  "use": "icon-arrow-down-notail-usage",
  "viewBox": "0 0 14 8",
  "content": "<symbol viewBox=\"0 0 14 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down-notail\">\n<path d=\"M1.09822 0.721539C1.21559 0.616164 1.34459 0.563477 1.48522 0.563477C1.62584 0.563477 1.74884 0.616164 1.85422 0.721539L7.47922 6.20591L13.1042 0.721539C13.2096 0.616164 13.3326 0.563477 13.4732 0.563477C13.6138 0.563477 13.7368 0.616164 13.8422 0.721539C13.9476 0.826914 14.0003 0.949914 14.0003 1.09054C14.0003 1.23116 13.9534 1.35416 13.8597 1.45954L7.86566 7.27804C7.76028 7.38341 7.63128 7.4361 7.47866 7.4361C7.32603 7.4361 7.19703 7.38341 7.09166 7.27804L1.09766 1.45954C1.00391 1.35416 0.957031 1.23116 0.957031 1.09054C0.957031 0.949914 1.00391 0.826914 1.09766 0.721539H1.09822Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow-down-notail.svg
// module id = Y8rV
// module chunks = 262